import {
  ADJUSTER_OPINION_BASE_PATH,
  POLICE_REPORT_BASE_PATH,
  SHOW_ADJUSTER_OPINION_BASE_PATH,
  SHOW_POLICE_REPORT_BASE_PATH,
} from '@/modules/adjusterReportModules/adjusterReport/AdjusterReportLinks';
import { ADJUSTER_REPORT_CULPRIT_IMAGES_ROUTES } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritImagesRoutes';
import { ADJUSTER_REPORT_CULPRIT_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritLinks';
import { ADJUSTER_REPORT_CULPRIT_INFORMATION_ROUTES } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritVehicleInformationRoutes';
import { ADJUSTER_REPORT_BODY_DAMAGE_IMAGES_ROUTES } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageImagesRoutes';
import { ADJUSTER_REPORT_BODY_DAMAGE_INFORMATION_ROUTES } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageInformationRoutes';
import { ADJUSTER_REPORT_BODY_DAMAGE_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
import { ADJUSTER_REPORT_DAMAGED_IMAGES_ROUTES } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedImagesRoutes';
import { ADJUSTER_REPORT_DAMAGED_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import { ADJUSTER_REPORT_DAMAGED_INFORMATION_ROUTES } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedVehicleInformationRoutes';
import AdjusterOpinion from '@/modules/adjusterReportModules/adjusterReport/pages/adjusterOpinion/AdjusterOpinion';
import ShowAdjusterOpinion from '@/modules/adjusterReportModules/adjusterReport/pages/adjusterOpinion/ShowAdjusterOpinion';
import AdjusterReportPage from '@/modules/adjusterReportModules/adjusterReport/pages/adjusterReportPage';
import PoliceReport from '@/modules/adjusterReportModules/adjusterReport/pages/policeReport/PoliceReport';
import ShowPoliceReport from '@/modules/adjusterReportModules/adjusterReport/pages/policeReport/ShowPoliceReport';
import { INCIDENT_DETAIL_BASE_PATH } from '@/modules/adjusterReportModules/IncidentDetails/IncidentDetailsLinks';
import { IncidentDetailsRoutes } from '@/modules/adjusterReportModules/IncidentDetails/IncidentDetailsRoutes';
import { INITIAL_VISIT_ROUTES } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitRoutes';
import { Outlet, RouteObject } from 'react-router-dom';

export const AdjusterReportRoutes: RouteObject[] = [
  {
    path: ':id',
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <AdjusterReportPage />,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION.base,
        element: <Outlet />,
        children: ADJUSTER_REPORT_CULPRIT_INFORMATION_ROUTES,
      },
      {
        path: ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.base,
        element: <Outlet />,
        children: ADJUSTER_REPORT_CULPRIT_IMAGES_ROUTES,
      },
      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.INFORMATION.base,
        element: <Outlet />,
        children: ADJUSTER_REPORT_DAMAGED_INFORMATION_ROUTES,
      },

      {
        path: ADJUSTER_REPORT_DAMAGED_PATHS.IMAGES.base,
        element: <Outlet />,
        children: ADJUSTER_REPORT_DAMAGED_IMAGES_ROUTES,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.base,
        element: <Outlet />,
        children: ADJUSTER_REPORT_BODY_DAMAGE_INFORMATION_ROUTES,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.base,
        element: <Outlet />,
        children: ADJUSTER_REPORT_BODY_DAMAGE_IMAGES_ROUTES,
      },
      {
        path: ADJUSTER_OPINION_BASE_PATH,
        element: <AdjusterOpinion />,
      },
      {
        path: POLICE_REPORT_BASE_PATH,
        element: <PoliceReport />,
      },
      {
        path: SHOW_ADJUSTER_OPINION_BASE_PATH,
        element: <ShowAdjusterOpinion />,
      },
      {
        path: SHOW_POLICE_REPORT_BASE_PATH,
        element: <ShowPoliceReport />,
      },
      {
        path: INCIDENT_DETAIL_BASE_PATH,
        element: <Outlet />,
        children: IncidentDetailsRoutes,
      },
      ...INITIAL_VISIT_ROUTES,
    ],
  },
];
